import * as React from 'react';
import footerImg from './chi-full-logo.png';

import './Footer.scss';

const currentYear = (new Date()).getFullYear();

export const Footer = () => (

    <footer className="site-footer">
        {/* The name is in the line beside the logo, so the logo has nothing to add for a screen reader */}
        <img src={footerImg} alt="" />
        <p>&copy; { currentYear } CHI Overhead Doors</p>
    </footer>

);
